<template>
  <ion-header>
    <ion-toolbar color="light">
      <ion-buttons class="back" slot="start">
        <ion-back-button aria-label="Back to previous screen" default-href="/home" text="" v-if="sharedState.showBackButton"></ion-back-button>
        <ion-button aria-label="Move Bookmark Up" v-if="sharedState.isBookmarkSelected" @click="moveBookmarkUp()">
          <ion-icon :icon="chevronUp" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
        <ion-button aria-label="Move Bookmark Down" v-if="sharedState.isBookmarkSelected" @click="moveBookmarkDown()">
          <ion-icon :icon="chevronDown" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title><img alt="alfrEDU Logo" src="/assets/img/alfrEDU-logo-header.svg"></ion-title>
      <ion-buttons class="other" slot="end">
        <ion-button aria-label="Open FAQ/About us" v-if="sharedState.currentIcon === 'faq'" @click="createModal('faq')">
          <ion-icon :icon="informationCircleOutline" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
        <ion-button aria-label="Open Bookmarks" v-if="sharedState.currentIcon === 'bookmark'" @click="createModal('bookmarks')">
          <BookmarkIcon />
        </ion-button>
        <ion-button aria-label="Delete Bookmark" v-if="sharedState.isBookmarkSelected" @click="deleteBookmark()">
          <ion-icon :icon="trash" color="danger" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
        <ion-button aria-label="Edit Bookmarks" v-if="sharedState.currentIcon === 'createOutline'" @click="reorderBookmarks()">
          <ion-icon :icon="reorderIcon" slot="icon-only" aria-hidden="true"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</template>

<script>
import { IonHeader, IonToolbar, IonTitle, IonButton, IonButtons, IonBackButton, IonIcon, modalController } from '@ionic/vue';
import { bookmark, bookmarkOutline, informationCircleOutline, checkmarkCircle, createOutline, trash, chevronUp, chevronDown } from 'ionicons/icons';
import FaqModal from '@/components/FaqModal.vue';
import BookmarksModal from '@/components/BookmarksModal.vue';
import BookmarkIcon from '@/components/BookmarkIcon.vue';
import { store } from '@/store';

export default  {
  name: 'AppHeader',
  components: { BookmarkIcon, IonHeader, IonToolbar, IonTitle, IonButton, IonButtons, IonBackButton, IonIcon },
  setup() {
    return {
      bookmark, bookmarkOutline, informationCircleOutline, checkmarkCircle, createOutline, trash, chevronUp, chevronDown
    }
  },
  data() {
    return {
      sharedState: store.state,
    }
  },
  computed: {
    reorderIcon: function() {
      return this.sharedState.isReordering ? checkmarkCircle: createOutline;
    },
    bookmarks: function() {
      return this.sharedState.bookmarks;
    }
  },
  mounted() {
    this.$el.querySelector('ion-back-button')?.addEventListener('click', () => this.closeSearch());
  },
  methods: {
    closeSearch() {
      store.updateItem('isSearching', false);
    },
    createModal: async function(type) {
      const types = {
        'faq': FaqModal,
        'bookmarks': BookmarksModal
      }
      const modal = await modalController.create({ component: types[type] });
      return modal.present();
    },
    reorderBookmarks: async function() {
      if (this.sharedState.isReordering) {
        await store.updateItem('isBookmarkSelected', false);
        await store.updateItem('bookmarkSelected', null);
      }
      await store.updateItem('isReordering', !this.sharedState.isReordering)
    },
    deleteBookmark: async function() {
      document.dispatchEvent(new CustomEvent('deleteBookmark', { detail: this.sharedState.bookmarkSelected }));
    },
    moveBookmarkUp: async function() {
      document.dispatchEvent(new CustomEvent('moveBookmarkUp', { detail: this.sharedState.bookmarkSelected }));
    },
    moveBookmarkDown: async function() {
      document.dispatchEvent(new CustomEvent('moveBookmarkDown', { detail: this.sharedState.bookmarkSelected }));
    },
  }
}
</script>

<style scoped>
  ion-header {
    --background: var(--ion-color-light); 
  }

  ion-toolbar {
    padding: 0.5rem 0;
  }
  
  img {
    padding-inline: 1rem;
    margin: 0 auto;
    display: block;
  }

  .back {
    position: absolute;
    left: 0.25em;
  }

  .other {
    position: absolute;
    right: 0.25em;
  }
</style>